<template>
    <div>
        <transition name="fade" enter-active-class="animated fadeIn"
                    leave-active-class="animated fadeOut"
                    :duration="300">
            <div class="cover-layer" v-show="isHotCityShow"></div>
        </transition>
        <transition name="bounce" enter-active-class="animated bounceInUp"
                    leave-active-class="animated fadeOut"
                    :duration="500">
            <div :class="productType=='256'?'m-search-content m-search-content-homestay':'m-search-content'" v-show="isHotCityShow" ref="hotCity">
                <div v-if="productType!='256'">
                    <div class="info">全球城市/酒店/地标，支持中文/英文/拼音/首字母搜索</div>
                    <ul class="content-list">
                        <li class="list-item">
                            <div class="list-content">
                                <div @click="selectHotel({N:'香港',I:'3201',F:'1'})"><span>香港</span></div>
                                <div @click="selectHotel({N:'澳门',I:'3301',F:'1'})"><span>澳门</span></div>
                                <div @click="selectHotel({N:'北京',I:'0101',F:'1'})"><span>北京</span></div>
                                <div @click="selectHotel({N:'上海',I:'0201',F:'1'})"><span>上海</span></div>
                                <div @click="selectHotel({N:'广州',I:'2001',F:'1'})"><span>广州</span></div>
                                <div @click="selectHotel({N:'深圳',I:'2003',F:'1'})"><span>深圳</span></div>
                                <div @click="selectHotel({N:'杭州',I:'1201',F:'1'})"><span>杭州</span></div>
                                <div @click="selectHotel({N:'成都',I:'2301',F:'1'})"><span>成都</span></div>
                                <div @click="selectHotel({N:'厦门',I:'1401',F:'1'})"><span>厦门</span></div>
                                <div @click="selectHotel({N:'三亚',I:'2201',F:'1'})"><span>三亚</span></div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="productType=='256'">
                    <div class="info">热门城市</div>
                    <ul class="content-list">
                        <li class="list-item">
                            <div class="list-content">
                                <div @click="selectHotel({F:'1',N:'北京',I:'0101'})"><span>北京</span></div>
                                <div @click="selectHotel({F:'1',N:'上海',I:'0201'})"><span>上海</span></div>
                                <div @click="selectHotel({F:'1',N:'广州',I:'2001'})"><span>广州</span></div>
                                <div @click="selectHotel({F:'1',N:'深圳',I:'2003'})"><span>深圳</span></div>
                                <div @click="selectHotel({F:'1',N:'杭州',I:'1201'})"><span>杭州</span></div>
                                <div @click="selectHotel({F:'1',N:'成都',I:'2301'})"><span>成都</span></div>
                                <div @click="selectHotel({F:'1',N:'厦门',I:'1401'})"><span>厦门</span></div>
                                <div @click="selectHotel({F:'1',N:'香港',I:'3201'})"><span>香港</span></div>
                                <div @click="selectHotel({F:'1',N:'澳门',I:'3301'})"><span>澳门</span></div>
                                <div @click="selectHotel({F:'1',N:'三亚',I:'2201'})"><span>三亚</span></div>
                                <div @click="selectHotel({F:'1',N:'秦皇岛',I:'0503'})"><span>秦皇岛</span></div>
                                <div @click="selectHotel({F:'1',N:'青岛',I:'1601'})"><span>青岛</span></div>
                                <div @click="selectHotel({F:'1',N:'南京',I:'1101'})"><span>南京</span></div>
                                <div @click="selectHotel({F:'1',N:'重庆',I:'0401'})"><span>重庆</span></div>
                                <div @click="selectHotel({F:'1',N:'大理',I:'2505'})"><span>大理</span></div>
                                <div @click="selectHotel({F:'1',N:'大连',I:'0801'})"><span>大连</span></div>
                                <div @click="selectHotel({F:'1',N:'西安',I:'2701'})"><span>西安</span></div>
                                <div @click="selectHotel({F:'1',N:'苏州',I:'1102'})"><span>苏州</span></div>
                                <div @click="selectHotel({F:'1',N:'昆明',I:'2501'})"><span>昆明</span></div>
                                <div @click="selectHotel({F:'1',N:'桂林',I:'2101'})"><span>桂林</span></div>
                                <div @click="selectHotel({F:'1',N:'济南',I:'1602'})"><span>济南</span></div>
                                <div @click="selectHotel({F:'1',N:'丽江',I:'2503'})"><span>丽江</span></div>
                                <div @click="selectHotel({F:'1',N:'黄山',I:'1302'})"><span>黄山</span></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "HotCity",
        props: {
            isHotCityShow: {
                type: Boolean,
                default: false
            },
            productType: {
                type: String,
                default: '4'
            }
        },
        data: function () {
            return {}
        },
        mounted() {
            this.addCloseListener();
            var that = this
            that.$nextTick(() => {
                if(localStorage.getItem('lang')=='t'){
                    that.$zh_tran(localStorage.getItem('lang'))
                }    
            })
        },
        methods: {
            selectHotel(obj) {
                this.$emit('select', obj)
            },
            addCloseListener() {
                let that = this;
                document.addEventListener('click', that.onClick,false);
            },
            onClick(e){
                if (e.target.className == 'searchAll' || this.$refs.hotCity && this.$refs.hotCity.contains(e.target)) return;
                this.$emit('select')
            }
        },
        destroyed(){
            document.removeEventListener('click', this.onClick,false)
        },
    }
</script>

<style scoped>
.m-search-content{
    width: 372px;
}
.m-search-content .list-item .list-content>div{
    width: 82px;
}
</style>



// WEBPACK FOOTER //
// src/components/realTimeSelection/comm/HotCity.vue